import * as React from 'react';
import './Overview.css';
import { ClassNames } from '../../_helpers/ClassNames';
import Image from '../Image/Image';
import { Link } from 'react-router-dom';

export type OverviewItemProps = ProjectPreviewDto & {
	OneColumnLayout: boolean;
};

export class OverviewItem extends React.Component<OverviewItemProps> {
	constructor(props: OverviewItemProps) {
		super(props);
	}

	render() {
		const { PreviewImage, PageTitle, PreviewLink, OneColumnLayout } =
			this.props;
		const sizes = `(max-width: 600px) 100vw, 
                    (min-width: 601px) and (max-width: 1280px) 45vw, 
                    (min-width: 1281px) 650px`;

		return (
			<article className={ClassNames('overview', 'figure-container')}>
				<figure className={ClassNames('overview', 'figure')}>
					<Image
						pictureRef={PreviewImage}
						className={ClassNames('overview', 'image')}
						sizes={sizes}
					/>
					{!OneColumnLayout && (
						<>
							<Link
								to={`/${PreviewLink}`}
								className={ClassNames('overview', 'link')}
							/>
							<figcaption className={ClassNames('overview', 'figcaption')}>
								{PageTitle}
							</figcaption>
						</>
					)}
				</figure>
				{OneColumnLayout && (
					<>
						<Link
							to={`/${PreviewLink}`}
							className={ClassNames('overview', 'link')}
						/>
						<figcaption
							className={ClassNames('overview', 'figcaption-one-column')}
						>
							{PageTitle}
						</figcaption>
					</>
				)}
			</article>
		);
	}
}
export default OverviewItem;



// WEBPACK FOOTER //
// ./src/Components/Overview/OverviewItem.tsx